import { engineComponent, NumberUtils, StringUtils } from "neo-common";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { CanvasManager } from "../Components/Managers/CanvasManager";
import { ImageTextElementAttributes } from "../Components/Elements/Texts/ImageTextElement";

@engineComponent(ComponentTypes.DisplayObject)
export class ImageTextFrameCounterElement extends ImageTextCounterElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private previousLetterCount: number;

    private startImage: ImageElement;

    private middleImage: ImageElement;

    private endImage: ImageElement;

    private middlePartWidth: number;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();
    }

    public createByNode(node: Element): void {
        let childs = CanvasManager.parseElements(node, this);
        if (childs != null) {
            if (childs["Middle"] != null) {
                this.middleImage = <ImageElement>childs["Middle"];
                this.middlePartWidth = this.middleImage.getBounds().width;
                this.addChild(this.middleImage);
            }

            if (childs["Start"] != null) {
                this.startImage = <ImageElement>childs["Start"];
                this.addChild(this.startImage);
            }

            if (childs["End"] != null) {
                this.endImage = <ImageElement>childs["End"];
                this.addChild(this.endImage);
            }
        }

        super.createByNode(node);
    }

    //******************************************************************************************************************
    //  REALIGN
    //******************************************************************************************************************

    public realign(): void {
        switch (this.textAlign) {
            case ImageTextElementAttributes.TEXT_ALIGN_VALUE.RIGHT:
                this.bitmapText.position.x = -this.bitmapText.width;
                this.startImage.position.x = -this.bitmapText.width;
                this.middleImage.position.x = -this.bitmapText.width;
                this.endImage.position.x = 0;
                break;
            case ImageTextElementAttributes.TEXT_ALIGN_VALUE.CENTER:
                this.bitmapText.position.x = -this.bitmapText.width * 0.5;
                this.startImage.position.x = -this.bitmapText.width * 0.5;
                this.middleImage.position.x = -this.bitmapText.width * 0.5;
                this.endImage.position.x = this.bitmapText.width * 0.5;
                break;
            default:
                this.bitmapText.position.x = 0;
                this.startImage.position.x = 0;
                this.middleImage.position.x = 0;
                this.endImage.position.x = this.bitmapText.width;
                break;
        }

        let scaleRatio = this.bitmapText.width / this.middlePartWidth;
        this.middleImage.scale.x = parseFloat(scaleRatio.toFixed(4));

        switch (this.textBaseline) {
            case ImageTextElementAttributes.TEXT_BASELINE_VALUE.BOTTOM:
                this.bitmapText.position.y = -this.bitmapText.height;
                break;
            case ImageTextElementAttributes.TEXT_BASELINE_VALUE.MIDDLE:
                this.bitmapText.position.y = -this.bitmapText.height * 0.5;
                break;
            default:
                this.bitmapText.position.y = 0;
                break;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/ImageTextFrameCounterElement.ts
 **/